import { TranslationKey } from "../translations/TranslationKey";

export enum TaskType {
  None = "None",
  CheckAvailability = "CheckAvailability",
  CheckCorrectionAvailability = "CheckCorrectionAvailability",
  Cancellation = "Cancellation",
  UploadDocuments = "UploadDocuments",
}

export const TaskTypeTranslationKey: { [taskType in TaskType]: TranslationKey } = {
  [TaskType.CheckAvailability]: "taskType.checkAvailability",
  [TaskType.CheckCorrectionAvailability]: "taskType.checkCorrectionAvailability",
  [TaskType.Cancellation]: "taskType.cancellation",
  [TaskType.UploadDocuments]: "taskType.uploadDocuments",
  [TaskType.None]: "taskType.none",
};
